import React, {Component, Fragment, type Node} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {DispatchType} from 'constants/flow/flowTypes';

import {ScrollBar} from 'components/__helpers/scrollBar/scrollBar';
import * as MenuActions from 'actions/menu/mainMenu';
import {getHeightFromCriteoNotifications} from 'libs/domManipulations/domManipulations';

import {defaultStructure} from './menuStructure';
import {Item} from './components/item/item';
import s from './menu.scss';

type MenuItemType = {
    component: Node,
    props: {
        title: string,
        to: string,
    },
    children: Array<MenuItemType>,
};

type PropsType = {
    visibilityMenu: {
        visible: boolean,
    },
    isCheckout: boolean,
    dispatch: DispatchType,
    structure?: Array<MenuItemType>,
    onMenuClose?: () => void,
};

/**
 *  Class for Menu
 */
export class Menu extends Component<PropsType> {
    static defaultProps = {
        structure: defaultStructure,
        onMenuClose: () => {},
    };

    /**
     * Close Menu onClick on empty place
     */
    closeMenu = () => {
        this.props.dispatch(MenuActions.visibilityMenu(false));
        this.props.onMenuClose();
    };

    /**
     * @param {Array<MenuItemType>} structure - Menu sections structure
     * @param {boolean} isMenuOpened - Open or closed menu
     * @returns {Node} - Rendered menu items structure
     */
    renderStructure = (structure: Array<MenuItemType>, isMenuOpened: boolean): Node =>
        structure.map((item: MenuItemType, index: number) => (
            <Item key={String(index)} {...item.props}>
                {item.children.length > 0 ? (
                    <item.component {...item.props} isMenuOpened={isMenuOpened}>
                        {this.renderStructure(item.children)}
                    </item.component>
                ) : (
                    <item.component {...item.props} isMenuOpened={isMenuOpened} />
                )}
            </Item>
        ));

    /**
     * Render jsx to html
     * @returns {Node} Rendered react component
     */
    render(): Node {
        const {visibilityMenu, structure} = this.props;

        const criteoHeight = getHeightFromCriteoNotifications();

        return (
            <Fragment>
                <div
                    className={classNames(s.wrapMainMenu, {[s.opened]: visibilityMenu.visible})}
                    style={{top: visibilityMenu.visible && criteoHeight ? criteoHeight : 0}}
                >
                    <div
                        onClick={this.closeMenu}
                        aria-label="Close menu"
                        className={classNames(s.close)}
                    >
                        <div className={s.cross} />
                    </div>

                    <div className={s.mainMenu}>
                        <ScrollBar className={s.menuArea}>
                            {this.renderStructure(structure, visibilityMenu.visible)}
                        </ScrollBar>
                    </div>
                </div>
                <div
                    className={classNames(s.backdrop, {
                        [s.backdropVisible]: visibilityMenu.visible,
                    })}
                />
            </Fragment>
        );
    }
}

export const MenuConnected = connect(store => ({
    visibilityMenu: store.visibilityMenu,
}))(Menu);
